
<div>
  <b-button-toolbar class="justify-content-center my-3">
    <b-button-group class="mr-3">
      <b-button variant="danger" @click="saveProduct"> Add To Quote</b-button>
    </b-button-group>
    <b-button-group>
      <b-button variant="link" @click="goBack"> Cancel</b-button>
    </b-button-group>
  </b-button-toolbar>
  <similar-products-dialog ref="similar_products_dialog"
                           :quote-product="quoteProduct"
                           @proceed-with-bto="proceedWithBTO"
                           @cancelled="handleSimilarProductsCancelled">
  </similar-products-dialog>
</div>
